import { getBuildimgmaterial, getNewBuildingColor, getNewDefaultBuilding } from "../../services/building-service";
import defaultBuildingImg from "../../assets/images/building-style/updatedIdealSteelBuilding/Carports.png";
import { const_var } from "../../redux/reducers/common/stateObjects";

export const initIntelDefaultlParams = (const_var) => {
	const params = new URLSearchParams(window.location.search);

	const isIntel = params.get("is_intel") === "true";
	const isIntelEdit = params.get("is_intel_edit") === "true";
	const_var.is_intel = isIntel;
	const_var.is_intel_edit = isIntelEdit;
	if (isIntel) {
		const_var.default_building_id = params.get("building");
		const_var.default_manufacturer_id = params.get("manufacturer");
		const_var.default_price_book_id = params.get("price_book");
		const_var.default_user_id = params.get("user_id");
		const_var.new_selected_default_building_id = params.get("default_building_id");
	}
};
export const setIntelDefaultBuilding = ({ const_var, defaultBuildingID, completeResponse, state, params, dimensionString, building_name }) => {
	if (!const_var?.is_intel) return;

	const_var.selectedDefaultIndex = defaultBuildingID;
	const getBaseBuildingObj = () => ({
		building_id: defaultBuildingID,
		name: building_name,
		image_name: "Carports.png",
		other_building_id: String(defaultBuildingID),
		roof_id: 3,
		size: dimensionString,
		wall: {
			front: "Open",
			back: "Open",
			right: "Open",
			left: "Open"
		}
	});

	const baseBuildingObj = getBaseBuildingObj();

	// 👉 Intel Edit Override Logic
	if (const_var.is_intel_edit && const_var.default_building_data?.configData) {
		const configData = const_var.default_building_data.configData;

		const_var.defaultBuildingArr[defaultBuildingID] = {
			...configData,
			id: defaultBuildingID,
			other_building_id: String(defaultBuildingID),
			utility: 0,
			image_url: const_var.default_building_data?.imageUrl
		};
	} else {
		const_var.defaultBuildingArr[defaultBuildingID] = baseBuildingObj;
	}
};
export const normalizeBuildingMaterials = (materials = []) => {
	return materials.map((mat) => ({
		...mat,
		label: mat.name,
		name: mat.slug,
		orientation: mat.orientation ?? "horizontal",
		panel_orientation: [mat.orientation ?? "horizontal"],
		panel_price_from: [mat.orientation ?? "horizontal"]
	}));
};
export const fetchDefaultBuildingApis = async ({ manufacturerId, buildingId, priceBookId }) => {
	const [newBuildingData, newBuildingColor, newBuildingMaterial] = await Promise.all([
		getNewDefaultBuilding({
			manufacturerId,
			buildingId,
			priceBookId,
			...(const_var?.is_intel_edit && { default_building_id: const_var.new_selected_default_building_id })
		}),

		getNewBuildingColor({
			manufacturerId
		}),

		getBuildimgmaterial({
			manufacturerId
		})
	]);

	return {
		newBuildingData,
		newBuildingColor,
		newBuildingMaterial
	};
};
export const ShowBuildingImage = ({ src, alt = "building-image", className = "" }) => {
	const handleError = (e) => {
		e.target.src = defaultBuildingImg;
	};

	return (
		<figure className={`media-figure ${className}`}>
			<img src={src || defaultBuildingImg} alt={alt} onError={handleError} />
		</figure>
	);
};
export const mapLean = (lean) => {
	if (!lean?.width) return {};

	return {
		size: `${lean.width}x${lean.length}x${lean.height}`,
		roof_pitch: lean.roof_pitch,
		position: lean.position,
		wall: {
			front_wall: lean.front_wall,
			back_wall: lean.back_wall,
			side_wall: lean.side_wall
		}
	};
};
export const getDoorSize = (entrySize = {}) => {
	const fixedSize = entrySize?.fixed_sizes?.[0];

	if (fixedSize) {
		return `${fixedSize?.width}x${fixedSize?.height}`;
	}

	return `${entrySize?.width}x${entrySize?.height}`;
};
export const appendFormData = (formData, data = {}) => {
	Object.entries(data).forEach(([key, value]) => {
		if (value !== undefined && value !== null) {
			formData.append(key, value);
		}
	});
};
